import { Pagination, type TablePaginationConfig } from "antd";
import Select from "../inputs/select";
import { Text } from "../text";
import useTranslation from "utils/hooks/useTranslation";

export const PaginationToolbar: React.FC<{
  total?: number;
  pagination: TablePaginationConfig;
  setPagination: (arg: TablePaginationConfig) => void;
}> = ({ total = 0, pagination, setPagination, ...rest }) => {
  const { t } = useTranslation();
  return <>
    {total > 0 && (
      <group
        data-align="center"
        data-space="5"
        //data-border=""
        data-gap="10"
        data-position="center"
        data-justify="center"
        //data-width="fit"
        {...rest}
      >
        <Pagination
          size="default"
          {...pagination}
          simple={false}
          showSizeChanger={false}
          total={total}
          onChange={(current) => {
            setPagination({ ...pagination, current });
          }}
        />

        <label data-type="group" data-interactive="" data-width="auto" data-align="center" data-wrap="no" data-radius="5" data-cursor="pointer" >

          <Text light data-space-horizontal="5">{t('CUSTOMER_SIZE')}</Text>

          <Select

            suffixIcon={null}
            borderLess
            showAction={["focus"]}
            popupMatchSelectWidth={false}
            //bordered={false}
            variant="borderless"
            options={[10, 25, 50, 100, 200, 500]}
            value={pagination.pageSize}
            onChange={(value: any) => {
              setPagination({ ...pagination, pageSize: value });
            }}
          />
        </label>
        <separator data-height="20"
          data-vertical=""
        ></separator>

        <Text light>{t('CUSTOMER_TOTAL')}</Text>
        <Text>{total}</Text>
      </group>
    )}
  </>
};
